<script setup>
// import { apexDashboard } from '@/data/dashboard/apexChart'
import { get_trait } from '@/services/packages';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import childInfoCard from '@/components/childInfoCard.vue';
import { retrieve_child } from '@/services/child';
import progress_item from './components/progress_item'
import currenAssessmentCard from './components/currentAssessmentCard'
import historyCard from './components/history_card'
import card_header from '@/components/card_header.vue';
import { get_trait_assessment } from '@/services/assessment';
import { swalError } from '@/helper';
import { get_trait_intervention } from '@/services/intervention';


const route = useRoute()
const trait_config = ref()
const isLoading = ref(true)
const child = ref({})
onMounted(async ()=>{
  let response = await get_trait(route.params.trait_id)
  let child_response = await retrieve_child(route.params.child_id)
  await parse_assessment_progress()
  await parse_intervention_progress()
  child.value = child_response.result.data.data
  trait_config.value = response.result.data
  parse_progress()
  isLoading.value = false
})

async function parse_intervention_progress(){
  let response = await get_trait_intervention({trait: route.params.trait_id, child: route.params.child_id})
  if (response.error){
    swalError(response.result.error)
    return
  }
  current_progress.value.intervention = {
    ...response.result.intervention,
    term: response.result.term
  }
}

const age_group_term = ref({})
const current_progress = ref({assessment: {}, intervention: {}})
async function parse_assessment_progress(){
  let response = await get_trait_assessment({trait: route.params.trait_id, child: route.params.child_id})
  if (response.error){
    swalError(response.result, true)
    return
  }
  current_progress.value.assessment = {
    ...response.result.assessments, 
    term: response.result.term
  }
}

const isShowBtn = ref(true)
async function showAll() {
  for (let item of current_progress.value.progress.slice(2)) {
    current_progress.value.showed_progress.push(item);
    await timeout(500);
  }
  isShowBtn.value = false
}

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function parse_progress(){
  let intervention_progress = []
  let assessment_progress = []
  intervention_progress = current_progress.value.intervention?.included?.filter((item)=> item.type == 'intervention_progress')
  assessment_progress = current_progress.value.assessment?.included?.filter((item)=> item.type == 'assessment_progress')
  let combine = assessment_progress.concat(intervention_progress)
  combine = combine.filter(item => item)
  let sorted = combine.sort((a,b) =>  parseInt(a.updated_at) - parseInt(b.updated_at))
  current_progress.value.progress = sorted
  current_progress.value.showed_progress = [...current_progress.value.progress].slice(0,3)
}

function printPage(){
  var printContents = document.getElementById('main_content').innerHTML;
  var originalContents = document.body.innerHTML;
  document.body.innerHTML = printContents;
  window.print();
  document.body.innerHTML = originalContents;
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Child Report">
      <div class="d-flex justify-content-end">
        <button class="btn btn-light-success"
          @click="printPage()"
        >
          Print Report
        </button>
      </div>
    </Breadcrumbs>
    
    <loadingCard v-if="isLoading" />
    <div v-else id="main_content">
      <!-- Child Info -->
      <childInfoCard class="col-md-6" :child="child"/>
      
      <div class="row report-history-progress">
        <!-- Current Assessment Graph -->
        <div class="col-md-6">
          <currenAssessmentCard :assessment="current_progress.assessment" />
        </div>

        <!-- Current Progress -->
        <div class="col-md-6">
          <div class="card">
            <card_header 
              :title="'Current Progress for ' + trait_config.attributes.name " 
              :has_border="true"
              :is_narrow="true"
              :extra_class="'justify-content-between'"
            >
              <div class="me-2">
                <div class="chart-card-info me-2">
                  <p class="mb-0">
                    Current Age Group :
                    <span>{{ current_progress.assessment.term.name || '-' }}</span>
                  </p>
                </div>
              </div>
            </card_header>
            
            <!-- List -->
            <div class="card-body" v-auto-animate>
              <EmptyCard 
                :needLink="false"
                v-if="current_progress.assessment.included.length == 0"
              />
              <template v-else v-for="item in current_progress.showed_progress" :key="item.id">
                <progress_item :item="item" :child="child" />
              </template>
              <div class="row" v-if="isShowBtn">
                <div class="text-center">
                  <button class="btn btn-light-success" @click="showAll()">
                    Show All Progress
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- History -->
      <historyCard 
        :child="child" 
        :trait="trait_config" 
        :isEmptyData = "current_progress.assessment.included.length == 0 ? true : false"
      />
      
    </div>
  </div>
</template>